import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  text: 'Descarga el manual y realiza la compra inicial de los 7 ingredientes básicos.'
}, {
  number: '2',
  text: "Sigue los protocolos de preparación y ten tu 'Estación de Calma' lista en la cocina."
}, {
  number: '3',
  text: 'Ante el próximo síntoma, aplica el método paso a paso y observa cómo tu hijo se relaja en minutos.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24" data-id="element-80">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-83">
            ¿Cómo funciona?
          </h2>
          <div className="w-24 h-1 bg-gold/50 mx-auto rounded-full" data-id="element-84"></div>
        </motion.div>

        <div className="relative" data-id="element-85">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-sage/20 -translate-y-1/2 z-0" data-id="element-86"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-87">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-88">
                <div className="w-16 h-16 rounded-full bg-sage text-white flex items-center justify-center text-2xl font-bold font-playfair mb-6 shadow-lg shadow-sage/20 border-4 border-cream" data-id="element-89">
                  {step.number}
                </div>
                <p className="text-lg text-brown-body leading-relaxed bg-cream md:bg-transparent px-4 py-2 rounded-lg" data-id="element-90">
                  {step.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}